import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import React from "react";
import {
  ARTICLE,
  CATEGORY,
  SUB_CATEGORY,
} from "../../Constants/RolesConstants";
import Article from "./Article";
import Category from "./Category";
import SubCategory from "./SubCategory";

let TABS = [
  {
    label: ARTICLE,
    Component: Article,
  },
  {
    label: SUB_CATEGORY,
    Component: SubCategory,
  },
  {
    label: CATEGORY,
    Component: Category,
  },
];

const SolutionMenu = ({ permissions }) => {
  const [value, setValue] = React.useState(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const filteredTabs = TABS.filter((element) =>
    permissions[element.label]?.canViewMenu == false ||
    permissions[element.label]?.canView == false
      ? false
      : true
  );

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="Org's">
            {filteredTabs.map((element, index) => {
              return <Tab label={element.label} value={index + 1} />;
            })}
          </TabList>
        </Box>
        {filteredTabs.map((element, index) => {
          const Component = element.Component;
          console.log("SolutionMenu permissions", permissions[element.label]);
          return (
            <TabPanel key={index} value={index + 1}>
              <Component componentPermissions={permissions[element.label]} />
            </TabPanel>
          );
        })}
      </TabContext>
    </Box>
  );
};

export default SolutionMenu;
